import { useAction, useAtom } from "@reatom/npm-react";
import { useEffect } from "react";

import { selectionIdAtom } from "../store/atoms/filterQuery";
import {
  restoreSelectionQuery,
  syncSelectionFromQuery,
} from "../store/atoms/selectionQuery";

export const useSelectionQuery = () => {
  const [selectionId] = useAtom(selectionIdAtom);
  const restoreSelection = useAction(restoreSelectionQuery);
  const syncSelection = useAction(syncSelectionFromQuery);

  useEffect(() => {
    restoreSelection();
  }, [restoreSelection]);

  useEffect(() => {
    syncSelection().catch(() => null);
  }, [selectionId, syncSelection]);
};
